import { Component, OnInit } from '@angular/core';
import {  MatDialogRef } from '@angular/material';


@Component({
  selector: 'app-popupdisplay',
  templateUrl: './popupdisplay.component.html',
  styleUrls: ['./popupdisplay.component.scss']
})
export class PopupdisplayComponent implements OnInit {

  public confirmMessage:HTMLDataElement;
  constructor(public dialogRef:MatDialogRef<PopupdisplayComponent>) { }

  ngOnInit() {
  }

}
